module.exports = __webpack_public_path__ + "img/14.340ffd3c.png";